/** Main project script */

// import packages and modules
const Swiper = require('swiper').default;
const jQuery = require('jquery');
const $ = jQuery;

// ensure the main object is defined
if (typeof(so) === 'undefined') {
    var so = {};
}

// main code
so.app = {
    init: function() {
        // eslint-disable-next-line no-unused-vars
        var focus = null;
        this.setupScrollHelper();
        this.megaMenuTrigger();
        this.toggleMobileMenu();
        this.mobileMenuTrigger();
        this.toggleAccordions();
        this.cyclePostImages();
        this.activateLightbox();
        this.configureCarousels();
        this.toggleTeamOverlay();
        this.wrapContentTables();
        this.watchVideoBanners();
        
        if (!$('header').first().hasClass('header-ignore')) {
            this.navColourChange();
            window.onscroll = function() { 
                so.app.navColourChange(); 
            };
        }

        // on esc key
        $(document).on('keyup', function(e) {
            if (e.key == "Escape") {
                var lightbox = $('#lightbox');
                if (!lightbox.hasClass('hidden')) {
                    so.app.closeLightbox();
                }
            }
        });
    },
    setupScrollHelper: function () {
        $('[data-scrollhelper]').each(function () {
            var windowScrollTop = $(window).scrollTop();
            var elScrollTop = $(this).offset().top;
            var cssClass = $(this).attr('data-class');
            var offsetBase = $(window).height();
            var presetClass = $(this).data('preset-class');
            var offset = parseInt($(this).attr('data-offset'));

            $(this).parents('section').addClass('animation-parent');

            if (windowScrollTop > (elScrollTop + offset)) {
                return false;
            }

            if (offset) {
                offset = offsetBase - offset;
            } else {
                offset = offsetBase - 100;
            }
            if (presetClass) {
                $(this).addClass(presetClass);
            }
            if (cssClass) {
                so.app.scrollHelper(this, cssClass, offset);
                this.addEventListener('animationstart', function() {
                    $(this).removeClass(presetClass);
                });
            }
        });
    },
    scrollHelper: function (el, elClass, offset, callback) {
        /*** Based on http://ejohn.org/blog/learning-from-twitter/ ***/
        var didScroll = false;
        var this_top;
        var top;

        if (!offset) {
            offset = 0;
        }

        $(window).on('scroll', function () {
            didScroll = true;
        });

        setInterval(function () {
            if (didScroll) {
                didScroll = false;
                top = $(this).scrollTop();

                $(el).each(function () {
                    this_top = $(this).offset().top - offset;

                    // Scrolled within current section
                    if (top >= this_top && !$(this).hasClass(elClass)) {
                        $(this).addClass(elClass);

                        if (typeof callback == "function") callback(el);
                    }
                });
            }
        }, 100);
    },
    megaMenuTrigger: function () {
        $(".mega-menu-trigger").on('mouseover', function(e) {
            e.preventDefault();

            so.app.closeMegaMenu();
            so.app.openMegaMenu(this);
        });
        $(".mega-menu-button").on('click', function(e) {
            e.preventDefault();

            var closed = $(this).parent().siblings(".mega-menu").hasClass('hidden');
            so.app.closeMegaMenu();

            if (closed) {
                so.app.openMegaMenu(this);
            }
        });
        $(".mega-menu").on('mouseleave', function() {
            so.app.closeMegaMenu();
        });
    },
    openMegaMenu: function (item) {
        $("header")
            .addClass('header-active')
            .removeClass('header-transparent');
        $(item).parent().siblings(".mega-menu")
            .addClass('absolute')
            .removeClass('hidden')
            .attr('aria-expanded', 'true')
            .css('opacity', 1);
        $(item).parent().find('.menu-arrow').first()
            .addClass('up');
    },
    closeMegaMenu: function () {
        $(".mega-menu")
            .addClass('hidden')
            .removeClass('absolute')
            .attr('aria-expanded', 'false')
            .css('opacity', 0);
        $(".menu-arrow")
            .removeClass('up');
    },
    toggleMobileMenu: function () {
        $("#mobile-toggle").on('click', function(e) {
            e.preventDefault();

            const menu = $('#mobile-menu');
            const isClosed = menu.hasClass('nav-closed');

            if (!isClosed) {
                menu.addClass('nav-closed');

                // close menu
                $('#mobile-opacity').addClass('hidden');
                $('body').css('overflow-y', 'visible');
                $('#main')
                    .removeAttr('inert')
                    .css('overflow', 'visible');
                $('footer')
                    .removeAttr('inert')
                    .css('overflow', 'visible');
                $(this)
                    .html('<i class="fa fa-bars"></i>')
                    .attr('aria-label', 'Open navigation');

                menu                       
                    .addClass('opacity-0 hidden')
                    .removeClass('opacity-100');
            } else {
                menu.removeClass('nav-closed');

                // open menu
                $('#mobile-opacity').removeClass('hidden');
                $('body').css('overflow-y', 'hidden');
                $('#main')
                    .attr('inert', '')
                    .css('overflow', 'hidden');
                $('footer')
                    .attr('inert', '')
                    .css('overflow', 'hidden');
                $(this)
                    .html('&#x2715;')
                    .attr('aria-label', 'Close navigation');

                menu.removeClass('hidden');

                // allow use of hidden while also allowing transition
                setTimeout(function () {
                    menu
                        .removeClass('opacity-0')
                        .addClass('opacity-100');
                }, 100);
            }
        });
    },
    mobileMenuTrigger: function () {
        $(".mobile-menu-trigger").click(function(e) {
            e.preventDefault();

            so.app.toggleMobileChildren(this);
        });
    },
    toggleMobileChildren: function (parent) {
        $(parent).parent().siblings(".mobile-children").toggleClass('hidden');
        $(parent).parent().parent().find('.menu-arrow').first().toggleClass('up');
    },
    toggleAccordions: function () {
        $('.accordion-trigger').on('click', function() {
            var content = $(this).siblings('.accordion-panel').first();
            $(this).toggleClass('border-b-[1px]');
            $(content).toggleClass('hidden');

            setTimeout(function () {
                $(content).toggleClass('opacity-0');
            }, 100);
        });
    },
    navColourChange: function () {
        var header = document.getElementById("site-nav");
        var transitionPoint = 44;
        var mobileIsHidden = $('#mobile-menu').hasClass('hidden');

        if (window.scrollY > transitionPoint && mobileIsHidden) {
            header.classList.remove("header-transparent");
            header.classList.add("header-active");
        } else {
            header.classList.remove("header-active");
            header.classList.add("header-transparent");
        }
    },
    cyclePostImages: function () {
        function cycle(el) {
            var imageID = el.dataset.image;

            $('#blog-image-' + imageID)
                .css('opacity', '1');

            $('.recent-blog-image').not('#blog-image-' + imageID)
                .css('opacity', '0');
        }

        $('.recent-post').each(function () {
            $(this).on('mouseover', function () {
                cycle(this);
            });

            $(this).focus(function () {
                cycle(this);
            });
        });
    },
    toggleTeamOverlay: function () {
        function show(image, item, opacity) {
            $(image).on('mouseover', function () {
                $(item)
                    .removeClass('opacity-0')
                    .addClass(opacity);
            });
        }

        function hide(image, item, opacity) {
            $(image).on('mouseleave', function () {
                $(item)
                    .removeClass(opacity)
                    .addClass('opacity-0');
            });
        }

        $('.team-image').each(function () {
            var overlay = $(this).find('.team-overlay').first();
            var text = $(this).find('.team-overlay-text').first();

            show(this, overlay, 'opacity-75');
            show(this, text, 'opacity-100');
            hide(this, overlay, 'opacity-75');
            hide(this, text, 'opacity-100');
        });
    },
    activateLightbox: function () {
        $('.activate-lightbox').each(function () {
            $(this).on('click', function (e) {
                e.preventDefault();
                so.app.openLightbox(this);
            });

            $(this).on('keypress', function(e) {
                if (e.key === "Enter") {
                    e.preventDefault();
                    so.app.openLightbox(this);
                }
            });
        });

        $('.close-lightbox').each(function () {
            $(this).on('click', function (e) {
                e.preventDefault();
                so.app.closeLightbox();
            });
        });
    },
    openLightbox: function (item) {
        so.app.focus = item;

        var lightbox = $('#lightbox');

        var id = item.dataset.id;
        var selectedLightbox = $('#lightbox-' + id);
        var content = selectedLightbox.html();

        lightbox.find('#lightbox-content').html(content);
        lightbox
            .removeClass('hidden')
            .removeAttr('inert');

        $('header').attr('inert', '');
        $('body').css('overflow', 'hidden');
        $('#main').attr('inert', '')
            .find('table').addClass('hidden'); // table screws with the lightbox scrolling
        $('footer').attr('inert', '');

        // allow use of hidden while also allowing transition
        setTimeout(function () {
            lightbox.removeClass('opacity-0');
        }, 100);
    },
    closeLightbox: function () {
        var lightbox = $('#lightbox');
        lightbox
            .addClass('opacity-0')
            .attr('inert', '');
        lightbox.find('#lightbox-content').html('<div></div>');

        $('header').removeAttr('inert', '');
        $('body').css('overflow', 'visible');
        $('#main').removeAttr('inert', '')
            .find('table').removeClass('hidden');
        $('footer').removeAttr('inert', '');

        setTimeout(function () {
            lightbox.addClass('hidden');
        }, 400);

        so.app.focus.focus();
    },
    configureCarousels: function () {
        const carousels = $('.carousel');
        carousels.each(function () {
            const carousel = this;
            const numOfSlides = $(carousel).find('.carousel-item').length;

            const canLoop = numOfSlides > 6;

            // eslint-disable-next-line no-unused-vars
            const swiper = new Swiper('#' + $(this).attr('id'), {
                direction: 'horizontal',
                loop: canLoop,
                grabCursor: true,
                keyboard: {
                    enabled: true,
                    onlyInViewport: false,
                },
                slidesPerView: 1,
                spaceBetween: 30,
                breakpoints: {
                    '576': {
                        slidesPerView: 2
                    },
                    '768': {
                        slidesPerView: 3
                    },
                }
            });
        });

        $('.carousel-button').each(function () {
            var carouselID = this.dataset.carousel;
            var carousel = $('#' + carouselID);

            var direction = this.dataset.action;

            $(this).on('click', function (e) {
                e.preventDefault();

                if (direction == 'left') {
                    carousel[0].swiper.slidePrev();
                }

                if (direction == 'right') {
                    carousel[0].swiper.slideNext();
                }
            });
        });
    },
    wrapContentTables: function () {
        const tables = $('.content > table');
        tables.each(function () {
            const table = $(this);
            const tableWrapper = $('<div class="overflow-x-scroll max-w-fit pb-2"></div>');
            table.wrap(tableWrapper);
        });
    },
    watchVideoBanners: function () {
        const banners = document.querySelectorAll('.solutionsoutsourced__videobanner__elements__videobanner');

        const callback = (entries, observer) => {
            entries.forEach(entry => {
                const element = entry.target;
                const bannerContent = element.querySelector('.banner-content');

                if (entry.intersectionRatio >= 0.85) {
                    bannerContent.classList.add('h-screen');
                    bannerContent.classList.remove('dynamic-width');
                    bannerContent.classList.add('w-full');
                    bannerContent.classList.remove('h-[500px]');
                    bannerContent.classList.remove('md:h-[720px]');
                } else if (entry.intersectionRatio <= 0.15) {
                    bannerContent.classList.remove('h-screen');
                    bannerContent.classList.add('dynamic-width');
                    bannerContent.classList.remove('w-full');
                    bannerContent.classList.add('h-[500px]');
                    bannerContent.classList.add('md:h-[720px]');
                }
            });
        };
        
        const observer = new IntersectionObserver(callback, { rootMargin: "0px", threshold: [0.15, 0.85]});
        banners.forEach(banner => {
            observer.observe(banner);
        });
    }
};

$(function() {
    so.app.init();
});
